import { AspectRatio, Box, Button, Flex, Heading, Image, Stack, Text } from "@chakra-ui/react";
import { ItineratorSimpleRegion } from "itinerator-api";
import { Link } from "@chakra-ui/next-js";
import { MarkdownOrHtml, ReactMarkdown } from "../Text";
import { useNavbarHeight } from "~/lib";

type IndexCommunityCardProps = {
  region: ItineratorSimpleRegion;
};
export const IndexCommunityCard = ({ region, ...props }: IndexCommunityCardProps) => {
  const image = region.lead_image?.thumbnail_url;
  return (
    <Flex
      flexDirection={{ base: "column" }}
      minH="100%"
      borderRadius="md"
      overflow="hidden"
      border="2px solid"
      borderColor="grey.900"
      {...props}
    >
      <AspectRatio ratio={16/9}>
        <Image
          w={{ base: "100%" }}
          h={{ base: "auto" }}
          src={image}
          fallbackSrc="/StopFillerImage.jpg"
          alt="Stop Image"
          objectFit="cover"
        />
      </AspectRatio>
      <Stack
        flexDirection="column"
        justifyContent={{ base: "space-between" }}
        p="24px"
        gap="16px"
      >
        {region.name && (
          <Heading fontSize={{ base: "xl", lg: "3xl" }}>{region.name}</Heading>
        )}
        {!!region.short_description && (
          <ReactMarkdown
            textProps={{
              noOfLines: { base: 4 },
              fontSize: { base: "sm", lg: "md" },
            }}
          >
            {region.short_description}
          </ReactMarkdown>
        )}
      </Stack>
      {region.slug && (
        <Stack
          flexDirection="column"
          justifyContent={{ base: "space-between" }}
          p="0 24px 24px 24px"
          gap="16px"
          mt="auto"
        >
            <Button
              size="sm"
              w="fit-content"
              as={Link}
              mt="auto"
              href={`communities/${region.slug}`}
            >
              Learn More
            </Button>
        </Stack>
        )}
    </Flex>
  );
};
